export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./reviews.vue?vue&type=template&id=9fc3d11a&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/base/modals/reviews.vue?vue&type=template&id=9fc3d11a&
// module id = 1334
// module chunks = 0